module.exports = __webpack_public_path__ + "static/media/engrafis-logo-2020@512.456e70f8.png";